// extracted by mini-css-extract-plugin
module.exports = {"root":"NumberCondition_root__3zYkr"};